import { FileSignature } from 'lucide-react';

export function PageSpinner() {
  return (
    <div className="flex flex-col items-center justify-center h-64 gap-4" data-testid="page-spinner">
      <div className="relative">
        <div className="w-16 h-16 rounded-full border-4 border-violet-100 border-t-violet-600 animate-spin"></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <FileSignature className="text-violet-600 animate-pulse" size={20} />
        </div>
      </div>
      <p className="text-sm text-slate-500 animate-pulse">Cargando...</p>
    </div>
  );
}
